<template>
  <v-container>
    <module-bar title="USUARIOS" icon="mdi-account">
      <template slot="menu">
        <v-btn color="primary" dark @click="openDialog('new')"
          >Registrar
        </v-btn>
      </template>
    </module-bar>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      style="max-width: 400px"
    ></v-text-field>
    <!-- Datatable -->
    <v-col cols="12">
      <v-data-table
        :items="users"
        :loading="loadingData"
        :headers="headers"
        :search="search"
        dense
        :mobile-breakpoint="800"
      >
        <template v-slot:[`item.avatar`]="{ item }">
          <v-avatar size="50" class="mt-2">
            <v-img
              :lazy-src="item.thumb_avatar ? item.thumb_avatar : avatarProfile"
              :src="item.avatar ? item.avatar : avatarProfile"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="white"
                    :width="3"
                    :size="50"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </template>
        <template v-slot:[`item.enabled`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="item.enabled ? 'green' : 'red'"
                size="16"
                v-bind="attrs"
                v-on="on"
              >
                mdi-circle
              </v-icon>
            </template>
            <span>{{ item.enabled ? "Habilitado" : "Deshabilitado" }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button
                icon
                v-bind="attrs"
                v-on="on"
                @click="openDialog('edit', item)"
              >
                <v-icon size="18">mdi-pencil</v-icon>
              </button>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button
                class="ml-2"
                icon
                v-bind="attrs"
                v-on="on"
                @click="changeStatus(item)"
              >
                <v-icon size="18">
                  {{ item.enabled ? "mdi-delete" : "mdi-check" }}
                </v-icon>
              </button>
            </template>
            <span>{{ item.enabled ? "Deshabilitar" : "Habilitar" }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog
      v-model="loadingDataId"
      hide-overlay
      persistent
      width="300"
      v-if="loadingDataId"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando datos...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-title>
          {{ dialogTitle }}
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Nombre completo"
                  v-model="fullName"
                  :rules="rulesFullName"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Email"
                  v-model="email"
                  :rules="rulesEmail"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Whatsapp"
                  v-model="whatsapp"
                  :rules="rulesWhatsapp"
                  :prefix="country.telephone_prefix"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="sex"
                  label="Sexo"
                  :items="sexes"
                  item-text="label"
                  item-value="value"
                  :rules="rulesSex"
                ></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <div v-if="permissionEmpty">
                  <p>Debe seleccionar al menos un permiso</p>
                </div>
                Permisos
                <v-treeview
                  hoverable
                  selectable
                  :items="permissions"
                  v-model="permissionsSelect"
                ></v-treeview>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            :loading="loadingForm"
            color="primary"
            dark
            @click="schema == 'new' ? register() : edit()"
            >{{ dialogBtnTitle }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import { mixinUser } from "../../mixins";
import avatar_profile from "../../assets/profile.jpeg";

export default {
  components: {
    ModuleBar,
  },

  mixins: [mixinUser],

  beforeMount() {
    this.loadingData = true;
    this.$store.dispatch("indexUsersAction");
    this.loadingData = false;
  },

  data() {
    return {
      loadingDataId: false,
      valid: false,
      search: "",
      loadingData: false,
      dialog: false,
      dialogTitle: "",
      schema: "",
      dialogBtnTitle: "",
      loadingForm: false,
      fullName: "",
      permissions: [],
      permissionsSelect: [],
      sex: 0,
      whatsapp: "",
      permissionEmpty: false,
      avatarProfile: avatar_profile,
      userPermissions: [],
      userId: 0,
      rulesFullName: [
        (fullName) =>
          (fullName && fullName.length >= 3) ||
          "Debe ingresar el nombre del usuario",
      ],

      rulesWhatsapp: [
        (whatsapp) => (whatsapp && whatsapp != "") || "Ingrese el Whatsapp",
      ],

      rulesSex: [(sex) => (sex && sex != 0) || "Selecciones el sexo"],

      headers: [
        {
          text: "Foto",
          value: "avatar",
        },
        {
          text: "Nombre",
          value: "full_name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Estado",
          aling: "center",
          value: "enabled",
        },
        {
          text: "Acciones",
          aling: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },

  computed: {
    sexes() {
      let general = this.$store.getters.getGeneral;
      let sexes = general.filter((g) => g.key == "sexes");
      return sexes;
    },

    country() {
      return this.$store.getters.getCountry;
    },

    users() {
      return this.$store.getters.getUsersAdmin;
    },
  },

  watch: {
    permissionsSelect: function (value) {
      if (value.length > 0) {
        this.permissionEmpty = false;
      } else {
        this.permissionEmpty = true;
      }
    },
  },

  methods: {
    openDialog(schema, item = null) {
      this.loadingDataId = true;
      setTimeout(() => {
        this.$store.dispatch("findPermissionsAction").then((res) => {
          this.permissions = res;
          if (schema == "new") {
            this.dialogTitle = "Nuevo usuario";
            this.dialogBtnTitle = "Guardar";
            this.dialog = true;
            this.loadingDataId = false;
            this.schema = schema;
          } else if (schema == "edit") {
            this.dialogTitle = "Editar usuario";
            this.dialogBtnTitle = "Editar";
            this.fullName = item.full_name;
            this.email = item.email;
            this.whatsapp = item.phone;
            this.sex = item.sex;
            this.userId = item.id;
            this.schema = schema;
            this.$store
              .dispatch("findPermissionsByUserAction", item.id)
              .then((res) => {
                this.userPermissions = res;
                for (let key in this.userPermissions) {
                  this.permissionsSelect.push(
                    this.userPermissions[key].permission_id
                  );
                }
                this.dialog = true;
                this.loadingDataId = false;
              });
          }
        });
      }, 500);
    },

    closeDialog() {
      this.dialog = false;
      this.clear();
    },

    clear() {
      this.fullName = "";
      this.email = "";
      this.sex = 0;
      this.whatsapp = "";
      this.permissionsSelect = [];
      this.permissionEmpty = false;
      this.$refs.form.resetValidation();
    },

    register() {
      if (this.valid && !this.permissionEmpty) {
        if (this.permissionsSelect.length > 0) {
          this.loadingForm = true;
          let payload = {
            rol: "admin",
            full_name: this.fullName,
            email: this.email,
            sex: this.sex,
            phone: this.whatsapp,
            permissions: this.permissionsSelect,
            country_id: this.country.id,
          };

          setTimeout(() => {
            this.$store
              .dispatch("registerUserAction", payload)
              .then(() => {
                this.dialog = false;
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }, 500);
        } else {
          this.permissionEmpty = true;
        }
      } else {
        this.$refs.form.validate();
        this.permissionEmpty = true;
      }
    },

    edit() {
      if (this.valid && !this.permissionEmpty) {
        if (this.permissionsSelect.length > 0) {
          this.loadingForm = true;
          let payload = {
            id: this.userId,
            full_name: this.fullName,
            email: this.email,
            sex: this.sex,
            phone: this.whatsapp,
            permissions: this.permissionsSelect,
          };
          this.$store
            .dispatch("editUserAction", payload)
            .then(() => {
              this.dialog = false;
              this.loadingForm = false;
            })
            .catch(() => {
              this.loadingForm = false;
            });
        } else {
          this.permissionEmpty = true;
        }
      } else {
        this.$refs.form.validate();
        this.permissionEmpty = true;
      }
    },
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
